import { fontHeading3 } from '../../styles/typographyNew';
import { classNames } from '../../utils/style';
import React from 'react';

export const VSColumn = ({
  title,
  picto,
  description,
  className,
  items,
}: any) => {
  return (
    <div
      className={classNames(
        'VSColumn',
        'p-[32px] lg:p-[42px] rounded-[32px]',
        'flex flex-col gap-40',
        className,
      )}
    >
      <div
        className={classNames(
          'VS__column_head',
          'flex flex-col gap-12',
          'max-w-[400px]',
        )}
      >
        {picto && <div className={classNames('VS__column_picto')}>{picto}</div>}
        <div
          className={classNames(
            'VS__column_head_content',
            'flex flex-col gap-8',
          )}
        >
          {title && (
            <div
              className={classNames(
                'VS__column_title',
                fontHeading3,
                'text-[#042040]',
              )}
            >
              {title}
            </div>
          )}
          {description && (
            <div className={classNames('VS__column_description')}>
              {description}
            </div>
          )}
        </div>
      </div>
      {items?.length > 1 && (
        <ul className={classNames('flex flex-col gap-24')}>
          {items.map((item: any, key: number) => (
            <li
              key={key}
              className={classNames(
                'VS__column_item',
                'flex items-center gap-16 p_bold',
              )}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </ul>
      )}
    </div>
  );
};
